<template>
    <div class="bd">

        <div class="my-custom-table">
            <a-page-header title="设置列表" />
            <div class="search-bar">
                <div class="tabInput">
                    <a>参数键：</a>
                    <a-input v-model:value="paramKey" placeholder="请输入参数键进行搜索" class="search-input" />
                </div>
                <div class="tab-button">
                    <div>
                        <a-button class="search-tow" type="primary" @click="onSearch"
                            :icon="h(SearchOutlined)">搜索</a-button>
                        <a-button class="search-tow" @click="onReset" :icon="h(RedoOutlined)">重置</a-button>
                    </div>
                    <div class="right-option">
                        <a-button type="primary" @click="toAdd" :icon="h(PlusCircleOutlined)">添加</a-button>
                        <!-- 添加数据 -->
                        <addComponent ref="childOpen" />
                    </div>
                </div>
            </div>

            <a-table :columns="columns" :data-source="data" :pagination="pagination" row-key="id">
                <template #bodyCell="{ column, record }">
                    <template v-if="column.dataIndex === 'paramKey'">
                        <span>
                            <a-tag color="green">
                                {{ record.paramKey }}
                            </a-tag>
                        </span>
                    </template>
                    <!-- 渲染操作按钮 -->
                    <template v-if="column.dataIndex === 'operation'">
                        <div class="editable-row-operations">
                            <a-popconfirm title="确认删除？" ok-text="是" cancel-text="否" @confirm="remove(record.id)">
                                <a style="margin: 15px;">删除</a>
                            </a-popconfirm>
                        </div>
                    </template>
                </template>
            </a-table>

        </div>
    </div>
</template>


<script>
import { setPage, removeSet } from '@/api/service'
import { cloneDeep } from 'lodash-es';
import { message } from 'ant-design-vue';
import { SearchOutlined, RedoOutlined, PlusCircleOutlined } from '@ant-design/icons-vue';
import { ref, h } from 'vue';
import addComponent from './modal/addComponent.vue'; // 导入组件
export default {
    name: 'SetPage',
    components: { addComponent },
    setup() {
        const data = ref([]); // 初始化为空数组
        const childOpen = ref(null);//子页面实例
        const paramKey = ref('');//查询条件
        const pagination = ref({
            current: 1, // 当前页数
            pageSize: 10, // 每页显示条数
            total: 0, // 数据总数
            showSizeChanger: true, // 是否显示修改每页条数
            showQuickJumper: true, // 是否显示快速跳转
            onChange: (page, pageSize) => {
                pagination.value.current = page;
                pagination.value.pageSize = pageSize;
                list(); // 当分页改变时，重新获取数据
            },
            position: ['bottomLeft']//显示位置
        });
        //列表
        const columns = [
            { title: '参数名', dataIndex: 'param', key: 'param', width: '10%', },
            { title: '参数键', dataIndex: 'paramKey', key: 'paramKey', width: '10%', },
            { title: '参数值', dataIndex: 'paramValue', key: 'paramValue', width: '40%', },
            { title: '备注', dataIndex: 'remark', key: 'remark', width: '30%', },
            { title: '操作', dataIndex: 'operation', width: '10%', },
        ];
        //查询数据
        const list = async () => {
            const response = await setPage({
                pageNumber: pagination.value.current,
                pageSize: pagination.value.pageSize,
                paramKey: paramKey.value
            });
            if (response.code === 200) {
                pagination.value.total = response.totalRow || response.data.totalRow || response.data.total || 0; // 更新 total
                data.value = response.data.records.map(item => ({
                    id: item.id,
                    param: item.param,
                    paramKey: item.paramKey,
                    paramValue: item.paramValue,
                    remark: item.remark,
                }));
            }
        };
        // 组件初始化时调用一次
        list();


        //删除菜单
        const deleteSet = async (data) => {
            const response = await removeSet(data);
            if (response.code === 200) {
                message.success('删除成功');
                return true;
            } else {
                message.error('删除失败' + response.msg);
                return false;
            }
        };
        //删除
        const remove = id => {
            if (deleteSet(id)) {
                data.value = cloneDeep(data.value.filter(item => id != item.id));
            }
        };
        //搜索
        const onSearch = () => {
            pagination.value.current = 1; // 搜索时重置当前页数
            list();
        }
        //重置
        const onReset = () => {
            paramKey.value = ''; // 重置搜索关键词
            list(); // 重置后重新获取数据
        }
        //添加
        const toAdd = () => {
            childOpen.value.open = true;
        }

        return {
            SearchOutlined,
            RedoOutlined,
            PlusCircleOutlined,
            childOpen,
            addComponent,
            paramKey,
            data,
            h,
            columns,
            toAdd,
            remove,
            onSearch,
            onReset,
            pagination,
        }
    }
}
</script>